import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import axios from 'axios'

const LOGIN_URL = "auth/login"
const REGISTER_URL = "auth/register"
const REQUEST_PASSWORD_URL = "auth/forgot-password"
const ME_URL = "auth/user"

// Función para validar y limpiar localStorage corrupto
const validateLocalStorage = () => {
  try {
    const authData = localStorage.getItem('persist:atcplus-auth')
    if (authData) {
      JSON.parse(authData)
    }
  } catch (error) {
    console.warn('Corrupted localStorage detected, clearing auth data:', error)
    localStorage.removeItem('persist:atcplus-auth')
  }
}

// Validar localStorage al inicializar
validateLocalStorage()

export const useAuthStore = create(
  persist(
    (set, get) => ({
      // Estado inicial
      user: undefined,
      roleName: undefined,
      authToken: undefined,
      permissions: undefined,
      serverTimeOffset: 0,

      // Estados de loading/error (no persistidos)
      loading: false,
      error: null,

      // Acciones
      login: async (authToken) => {
        try {
          set({ authToken, user: undefined, loading: true, error: null })
          await get().requestUser()
        } catch (error) {
          set({ error: error.message, loading: false })
          throw error
        }
      },

      setAuthToken: async (authToken) => {
        try {
          set({ authToken, user: undefined, loading: true, error: null })
          await get().requestUser()
        } catch (error) {
          set({ error: error.message, loading: false })
          throw error
        }
      },

      register: async (authToken) => {
        try {
          set({ authToken, user: undefined, loading: true, error: null })
          await get().requestUser()
        } catch (error) {
          set({ error: error.message, loading: false })
          throw error
        }
      },

      logout: () => {
        set({
          user: undefined,
          roleName: undefined,
          authToken: undefined,
          permissions: undefined,
          serverTimeOffset: 0,
          loading: false,
          error: null
        })
      },

      setServerTimeOffset: (offset) => {
        set({ serverTimeOffset: offset })
      },

      getServerTimeOffset: () => get().serverTimeOffset,

      requestUser: async () => {
        try {
          set({ loading: true, error: null })
          const response = await axios.get(ME_URL)
          const user = response.data
          
          set({ 
            user, 
            permissions: user?.role?.privileges, 
            roleName: user?.role?.name,
            loading: false 
          })
        } catch (error) {
          set({ error: error.message, loading: false })
          throw error
        }
      },

      // Funciones auxiliares de auth (para mantener compatibilidad)
      loginAPI: async (userName, password) => {
        return axios.post(LOGIN_URL, { userName, password })
      },

      registerAPI: async (email, fullname, username, password) => {
        return axios.post(REGISTER_URL, { email, fullname, username, password })
      },

      requestPasswordAPI: async (email) => {
        return axios.post(REQUEST_PASSWORD_URL, { email })
      },

      clearError: () => set({ error: null })
    }),
    {
      name: 'atcplus-auth',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        user: state.user,
        authToken: state.authToken,
        permissions: state.permissions,
        roleName: state.roleName,
        serverTimeOffset: state.serverTimeOffset
      })
    }
  )
) 